import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <section className="section page-section">
            <span className="section-label">404</span>
            <h1 className="page-title">Page not found</h1>
            <p className="section-desc">The page you are looking for does not exist.</p>
            <Link className="btn-submit inline" to="/" style={{ textDecoration: 'none' }}>Back to start</Link>
        </section>
    );
}
